/**
 * FMA Account Dashboard Tour Steps
 * Tour for profile management and gamification features
 */
import { Step } from "react-joyride";

export const fmaAccountSteps: Step[] = [
  {
    target: "body",
    content:
      "Welcome to your Account Dashboard! Let's customize your profile and maximize your success on the platform.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tour="overview-tab"]',
    content:
      "The Overview tab shows your path to success. Complete these steps to increase visibility and earn rewards.",
    placement: "bottom",
    disableScrolling: true,
  },
  {
    target: '[data-tour="success-checklist"]',
    content:
      "Follow this checklist: complete your profile, post training videos, invite connections, and climb the leaderboard.",
    placement: "top",
  },
  {
    target: '[data-tour="profile-tab"]',
    content:
      "Click the Profile tab (highlighted in gold) to continue the tour and edit your information.",
    placement: "bottom",
    spotlightClicks: true,
    disableBeacon: true,
    hideFooter: true,
    styles: {
      spotlight: {
        borderRadius: '8px',
        boxShadow: '0 0 0 9999px rgba(0, 0, 0, 0.5), 0 0 20px 8px rgba(255, 215, 0, 0.8)',
      },
    },
  },
  {
    target: '[data-tour="profile-form"]',
    content:
      "Fill in your contact details, location & coverage areas, and professional experience. A complete profile increases trust and improves your search ranking.",
    placement: "top",
    disableScrolling: true,
  },
  {
    target: '[data-tour="points-tab"]',
    content:
      "Click the Points tab (highlighted in gold) to continue the tour and discover how gamification works!",
    placement: "bottom",
    spotlightClicks: true,
    disableBeacon: true,
    disableScrolling: true,
    hideFooter: true,
    styles: {
      spotlight: {
        borderRadius: '8px',
        boxShadow: '0 0 0 9999px rgba(0, 0, 0, 0.5), 0 0 20px 8px rgba(255, 215, 0, 0.8)',
      },
    },
  },
  {
    target: '[data-tour="points-display"]',
    content:
      "Your total points and current rank (Bronze, Silver, Gold, etc.) are shown here. Earn more to increase your standing and grow your agency faster!",
    placement: "top",
  },
  {
    target: '[data-tour="earn-points-list"]',
    content:
      "Earn points by: daily login, completing your profile, uploading training videos, and referring others.",
    placement: "left",
  },
  {
    target: '[data-tour="rewards-section"]',
    content:
      "As you rank up, you'll unlock rewards like premium badges, featured listings, and higher likelihood of getting more interviews booked.",
    placement: "bottom",
  },
  {
    target: '[data-tour="referral-link"]',
    content:
      "Share your unique referral link to invite agencies and agents. You'll earn bonus points for each agency signup! (Don't worry, we already built the landing page to explain the benefits.)",
    placement: "top",
  },
];
